import React from "react";

function Hero({index, bgFromIndex}) {
  return (
    <section id="hero" className="hero-section" style={{backgroundColor: bgFromIndex(index)}}>
      <div className="section-header"></div>
      <img className="logo"  src="/assets/icon.png"></img>
      <h2>Challenge Your Brain!</h2>
      <p id="hero1">
        With the most intuitive and feature-rich Sudoku
        experience.
      </p>
      <p id="hero2">
        Unleash your brainpower with Sudoku Master, the ultimate Sudoku
        experience! Whether you're a beginner or a seasoned expert, Sudoku
        Master offers puzzles for all levels.
      </p>
      <p>
        Train your brain, sharpen your logic, and have fun while solving endless
        grids of Sudoku!
      </p>
      <a href="#download" className="cta-button">
        Download Now
      </a>
    </section>
  );
}

export default Hero;
